exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guidelines-message {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n  max-width: 320px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js??ref--2-3!./src/components/reviewForm/reviewForm.scss
// module id = 2586
// module chunks = 0